var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from 'react';
import { styled } from '@mui/material/styles';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Loader } from './Loader';
import TablePagination from '@mui/material/TablePagination';
import { Box, TableSortLabel, Typography, Stack, Tooltip, CardContent, Card, } from '@mui/material';
import { CardTitle } from './CardTitle';
import { IconButton } from './IconButton';
import { classTotal, getBackgroundColor, getColors } from './Classes';
import { ExportIcon, AddIcon } from './Icons';
import { getFiltres, getIsMobile } from '../services/utilisateur';
import { Definitions } from './Definitions';
import { convertFiltresToResults, FiltresV2 } from './FiltresV2';
var StyledTableRow = styled(TableRow)(function (_a) {
    var theme = _a.theme;
    return ({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    });
});
export var renderInfo = function (info, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.right, right = _c === void 0 ? false : _c, _d = _b.color, color = _d === void 0 ? null : _d, _e = _b.tooltip, tooltip = _e === void 0 ? null : _e;
    var component = (_jsx(Typography, __assign({ variant: "body2", className: "".concat(right ? 'absolute-right mr-small' : 'absolute', " bold text-smaller nowrap"), sx: { color: color ? color : 'primary.main', bottom: 1 } }, { children: info })));
    if (tooltip) {
        return (_jsx(Tooltip, __assign({ disableInteractive: true, title: tooltip }, { children: component })));
    }
    return component;
};
export var Table = function (props) {
    var _a = props.title, title = _a === void 0 ? null : _a, _b = props.headers, headers = _b === void 0 ? [] : _b, _c = props.datas, datas = _c === void 0 ? [] : _c, _d = props.total, total = _d === void 0 ? null : _d, _e = props.typeFiltre, typeFiltre = _e === void 0 ? null : _e, _f = props.refresh, refresh = _f === void 0 ? null : _f, _g = props.onExport, onExport = _g === void 0 ? null : _g, _h = props.canEdit, canEdit = _h === void 0 ? false : _h, _j = props.canAdd, canAdd = _j === void 0 ? true : _j, _k = props.renderModalEdition, renderModalEdition = _k === void 0 ? null : _k, _l = props.renderButtons, renderButtons = _l === void 0 ? null : _l, _m = props.renderFooter, renderFooter = _m === void 0 ? null : _m, _o = props.footerTotal, footerTotal = _o === void 0 ? null : _o, _p = props.color, color = _p === void 0 ? 'primary' : _p, _q = props.isResponsive, isResponsive = _q === void 0 ? false : _q;
    var palette = getColors();
    var _r = useState(false), loading = _r[0], setLoading = _r[1];
    var _s = useState(null), orderBy = _s[0], setOrderBy = _s[1];
    var _t = useState('asc'), order = _t[0], setOrder = _t[1];
    var _u = useState(0), page = _u[0], setPage = _u[1];
    var _v = useState(10), rowsPerPage = _v[0], setRowsPerPage = _v[1];
    var _w = useState(false), showModalEdition = _w[0], setShowModalEdition = _w[1];
    var _x = useState({}), paramsToUpdate = _x[0], setParamsToUpdate = _x[1];
    var _y = useState(typeFiltre ? convertFiltresToResults(getFiltres(typeFiltre)) : null), filtres = _y[0], setFiltres = _y[1];
    var columns = headers.filter(function (header) { return !header.hidden; });
    var isMobile = getIsMobile();
    useEffect(function () {
        var getDatas = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, refresh({
                                page: page + 1,
                                itemByPage: rowsPerPage,
                                filtres: filtres,
                                order: orderBy
                                    ? {
                                        by: orderBy.split(','),
                                        isAsc: order === 'asc',
                                    }
                                    : null,
                            })];
                    case 1:
                        _a.sent();
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (refresh) {
            getDatas();
        }
    }, [page, rowsPerPage, orderBy, order, filtres]);
    var handleChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        var newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };
    var createSortHandler = function (property) { return function () {
        var isAsc = orderBy === property && order === 'asc';
        var newOrder = isAsc ? 'desc' : 'asc';
        setPage(0);
        setOrder(newOrder);
        setOrderBy(property);
    }; };
    var handleSearch = function (newFiltres) {
        setFiltres(newFiltres);
    };
    var handleClickDownload = function () {
        if (onExport) {
            onExport(filtres);
        }
    };
    var handleClose = function () {
        setShowModalEdition(false);
        setParamsToUpdate({});
        setFiltres(__assign({}, filtres));
    };
    var renderPagination = function (displayButtons) {
        if (displayButtons === void 0) { displayButtons = false; }
        return total !== null || displayButtons ? (_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [total !== null ? (_jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [_jsx(Tooltip, __assign({ disableInteractive: true, title: "Total" }, { children: _jsx(Typography, __assign({ sx: classTotal(palette[color]), variant: "h6" }, { children: total })) })), _jsx(Stack, __assign({ direction: "row", alignItems: "center" }, { children: _jsx(TablePagination, { rowsPerPageOptions: [10, 25, 50], component: "div", count: total, rowsPerPage: rowsPerPage, page: page, labelRowsPerPage: _jsx("span", { children: "Par page" }), labelDisplayedRows: function (_a) {
                                    var page = _a.page;
                                    return "Page : ".concat(page + 1, "/").concat(Math.ceil(total / rowsPerPage));
                                }, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }) }))] }))) : (_jsx("div", {})), displayButtons && renderButtonsActions()] }))) : (_jsx(_Fragment, {}));
    };
    var renderButtonsActions = function () {
        var buttons = [];
        var components = [];
        if (canEdit && renderModalEdition) {
            if (showModalEdition) {
                components.push(renderModalEdition(handleClose, paramsToUpdate));
            }
            if (canAdd) {
                buttons.push(_jsx(IconButton, __assign({ color: "primary", tooltip: "Ajouter", onClick: function () { return setShowModalEdition(true); } }, { children: _jsx(AddIcon, {}) })));
            }
        }
        if (onExport) {
            buttons.push(_jsx(IconButton, __assign({ color: "primary", tooltip: "Exporter", onClick: function () { return handleClickDownload(); } }, { children: _jsx(ExportIcon, {}) })));
        }
        if (renderButtons) {
            buttons.push(renderButtons());
        }
        return (_jsxs(_Fragment, { children: [buttons.length ? (_jsx(Stack, __assign({ alignItems: "center", spacing: 2, direction: "row-reverse" }, { children: buttons.map(function (button, index) { return (_jsxs(Fragment, { children: [" ", button] }, index)); }) }))) : (_jsx(_Fragment, {})), components.map(function (component, index) { return (_jsxs(Fragment, { children: [" ", component] }, index)); })] }));
    };
    var renderHeader = function (header, index) {
        if (index === void 0) { index = null; }
        var direction = order === 'asc' ? 'asc' : 'desc';
        return (_jsx(TableCell, __assign({ sx: getBackgroundColor(palette, color), sortDirection: orderBy === header.orderBy ? direction : false, colSpan: index === null ? columns.length : 1, align: header.align ? header.align : 'left' }, { children: header.orderBy ? (_jsxs(TableSortLabel, __assign({ active: orderBy === header.orderBy, direction: direction, onClick: createSortHandler(header.orderBy) }, { children: [header.label, orderBy === header.orderBy ? _jsx(Box, { component: "span" }) : null] }))) : (header.label) }), index));
    };
    var getContent = function (header, data, forceColor) {
        if (forceColor === void 0) { forceColor = null; }
        var content = '';
        if (header.component) {
            content = header.component(data, {
                color: forceColor ? forceColor : color,
                refresh: handleClose,
                handleUpdate: function (params) {
                    setParamsToUpdate(params);
                    setShowModalEdition(true);
                },
            });
        }
        else if (header.assessor) {
            if (header.assessor.includes('.')) {
                content = data;
                for (var _i = 0, _a = header.assessor.split('.'); _i < _a.length; _i++) {
                    var assessorItem = _a[_i];
                    if (content) {
                        content = content[assessorItem];
                    }
                }
            }
            else {
                content = data[header.assessor];
            }
        }
        if (header.hidden) {
            return '';
        }
        return content;
    };
    var renderCards = function () {
        return (_jsx(Stack, __assign({ spacing: 1 }, { children: datas.map(function (data, index) {
                var titleHeader = columns.length > 0 ? columns[0] : null;
                var titleContent = titleHeader
                    ? getContent(titleHeader, data, 'white')
                    : null;
                return (_jsxs(Card, { children: [titleContent && _jsx(CardTitle, { title: titleContent, color: color }), _jsx(CardContent, __assign({ className: "p-none" }, { children: _jsx(Definitions, { datas: columns
                                    .filter(function (header, index) { return titleContent && index > 0; })
                                    .reduce(function (accumulator, header) {
                                    var content = getContent(header, data);
                                    if (content) {
                                        accumulator.push({
                                            label: header.label,
                                            value: content,
                                        });
                                    }
                                    return accumulator;
                                }, []) }) }))] }, index));
            }) })));
    };
    var renderTable = function () {
        var renderCell = function (header, content, indexHeader, rowSpan) {
            if (indexHeader === void 0) { indexHeader = 0; }
            if (rowSpan === void 0) { rowSpan = 1; }
            return (_jsx(TableCell, __assign({ sx: __assign(__assign({}, (header.isHeader
                    ? __assign(__assign({}, getBackgroundColor(palette, color)), { border: 2, position: 'inherit' }) : {})), (header.minWidth ? { width: 0 } : {})), rowSpan: rowSpan, align: header.align ? header.align : content ? 'left' : 'center' }, { children: content ? content : '-' }), indexHeader));
        };
        return (_jsx(TableContainer, __assign({ component: Paper }, { children: _jsxs(MuiTable, { children: [columns.filter(function (header) { return header.label; }).length ? (_jsx(TableHead, { children: _jsx(TableRow, { children: columns.map(function (header, index) { return renderHeader(header, index); }) }) })) : (_jsx(_Fragment, {})), _jsx(TableBody, { children: loading ? (_jsx(StyledTableRow, { children: _jsx(TableCell, __assign({ colSpan: columns.length }, { children: _jsx(Loader, {}) })) })) : datas.length === 0 ? (_jsx(StyledTableRow, { children: _jsx(TableCell, __assign({ colSpan: columns.length, align: "center" }, { children: _jsx(Typography, { children: "-" }) })) })) : (_jsxs(_Fragment, { children: [datas.map(function (data, index) { return (_jsx(StyledTableRow, { children: columns.map(function (header, indexHeader) {
                                        var content = getContent(header, data);
                                        var rowSpan = 1;
                                        if (header.groupByRow) {
                                            rowSpan = datas.filter(function (item) {
                                                return item[header.assessor] ===
                                                    datas[index][header.assessor];
                                            }).length;
                                            if (rowSpan > 1 &&
                                                datas[index - 1] &&
                                                datas[index - 1][header.assessor] ===
                                                    datas[index][header.assessor]) {
                                                return _jsx(Fragment, {}, indexHeader);
                                            }
                                        }
                                        return renderCell(header, content, indexHeader, rowSpan);
                                    }) }, index)); }), footerTotal && footerTotal.length && (_jsx(StyledTableRow, { children: footerTotal.map(function (total, index) {
                                        return renderCell({
                                            isHeader: true,
                                            align: index === 0 ? 'left' : 'right',
                                        }, total, index);
                                    }) }))] })) })] }) })));
    };
    return (_jsxs(Stack, __assign({ className: "w-full" }, { children: [typeFiltre && (_jsx(FiltresV2, { color: color, title: title, Type: typeFiltre, handleSearch: handleSearch })), _jsx(Stack, __assign({ direction: isMobile ? 'column-reverse' : 'row' }, { children: _jsxs(Stack, __assign({ className: "w-full" }, { children: [!typeFiltre && title && _jsx(CardTitle, { color: color, title: title }), renderPagination(true), isResponsive && isMobile ? renderCards() : renderTable(), renderPagination(), renderFooter && renderFooter()] })) }))] })));
};
//# sourceMappingURL=Table.js.map